import { render, staticRenderFns } from "./websiteInformation.vue?vue&type=template&id=166b85bc&"
import script from "./websiteInformation.vue?vue&type=script&lang=js&"
export * from "./websiteInformation.vue?vue&type=script&lang=js&"
import style0 from "./websiteInformation.vue?vue&type=style&index=0&id=166b85bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports